/**
 * Ordering screens hide modifier choices the admin marked unavailable
 * (available === false), so they can't be picked or pre-selected as defaults.
 * Admin screens use the raw menu so choices can be switched back on.
 */
export function withoutUnavailableChoices<T>(items: T[]): T[] {
  if (!Array.isArray(items)) return items;
  return items.map((item: any) => {
    if (!Array.isArray(item?.customize)) return item;
    return {
      ...item,
      customize: item.customize.map((opt: any) =>
        Array.isArray(opt?.choices)
          ? { ...opt, choices: opt.choices.filter((c: any) => c?.available !== false) }
          : opt,
      ),
    };
  });
}
